import classNames from 'classnames';
import { ServiceIcon } from '../../../generated/graphql';
import {
  CALENDLY_COLOR_MAP,
  getIconComponent,
} from '../../components/ServiceCard/helpers';
import { shouldUseProviderPrimaryColor } from '../../lib/colors';

type ServiceIconItemValue = {
  icon: ServiceIcon;
  isCalendlyDefaultColor: boolean;
  color: string;
  providerPrimaryColor: string | null;
};

const ServiceIconItem: React.FC<{
  value: ServiceIconItemValue;
}> = ({ value }) => {
  const { icon, isCalendlyDefaultColor, color, providerPrimaryColor } = value;

  const IconComponent = getIconComponent(icon);

  const useProviderPrimaryColor =
    shouldUseProviderPrimaryColor(providerPrimaryColor);

  return (
    <span className="flex items-center text-caption">
      {IconComponent && (
        <IconComponent
          className={classNames(
            'h-6 w-6',
            isCalendlyDefaultColor
              ? Boolean(CALENDLY_COLOR_MAP?.[color])
                ? CALENDLY_COLOR_MAP[color]
                : useProviderPrimaryColor
                ? 'text-primary-125'
                : 'text-blue-100'
              : useProviderPrimaryColor
              ? 'text-primary-125'
              : 'text-blue-100',
          )}
        />
      )}
    </span>
  );
};

export default ServiceIconItem;
